export default __webpack_public_path__ + "static/resinring-fe12268603ba65eb49df287a45a01a27.png";